<template>
    <div class="dialogBox">
        <!-- 登录弹框 -->
        <el-dialog
        class="login-dialog"
        :show-close="false"
        :title="isloginpage? '欢迎登录' : '欢迎注册'"
        :visible.sync="dialogVisible"
        width="480px"
        :close-on-click-modal="false"
        @close="closeLogin">
            <div class="login-content" v-if="isloginpage">
                <i class="el-icon-close login-close" @click="closeLogin"></i>
                <div class="loginInfo">
                    <input
                    type="text"
                    class="form-control"
                    v-model="userName"
                    placeholder="请输入您的账号"
                    maxlength="20"
                    required />
                    <input
                    type="password"
                    class="form-control"
                    v-model="password"
                    @keyup.enter="goLogin"
                    placeholder="请输入您的密码"
                    maxlength="20"
                    required />
                    <span class="defaultReminder">*默认密码为手机号后四位</span>
                    <button class="btn-login" @click="goLogin">立即登录</button>
                </div>
                <div class="login-default-div">
                    <span class="login-default" @click="goRetrievePasswords">忘记密码</span>
                    <span class="login-default" @click="isloginpage=false">注册账号</span>
                </div>
            </div>
            <div class="login-content" v-else>
                <i class="el-icon-close login-close" @click="closeLogin"></i>
                <el-form
                :model="userObj"
                status-icon
                :rules="rules"
                size="medium "
                ref="registration"
                label-width="100px"
                class="demo-ruleForm">
                    <el-form-item label="账号" prop="username">
                        <el-input v-model.number="userObj.username" placeholder="请输入账号"></el-input>
                    </el-form-item>
                    <el-form-item label="密码" prop="password">
                        <el-input
                        type="password"
                        v-model="userObj.password"
                        placeholder="请输入密码"
                        autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="确认密码" prop="checkPassword">
                        <el-input
                        type="password"
                        v-model="userObj.checkPassword"
                        placeholder="请再次输入密码"
                        autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="姓名" prop="name">
                        <el-input v-model.number="userObj.name" placeholder="请输入姓名"></el-input>
                    </el-form-item>
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model.number="userObj.phone" placeholder="请输入手机号">
                        <el-button
                            :disabled="phoneCodeDisabled"
                            slot="append"
                            @click="getPhoneCode('registration')">{{ count ? count + "s 后重发" : "获取验证码"}}</el-button>
                        </el-input>
                    </el-form-item>
                    <el-form-item label="验证码" prop="phoneCode">
                        <el-input v-model.number="userObj.phoneCode" placeholder="请输入验证码"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitRegistration('registration')">提交</el-button>
                        <el-button @click="resetForm('registration')">重置</el-button>
                    </el-form-item>
                </el-form>
                <div class="login-default-div">
                    <span class="login-default" @click="goRetrievePasswords">忘记密码</span>
                    <span class="login-default" @click="isloginpage=true">返回登录</span>
                </div>
            </div>
        </el-dialog>
        <!-- 修改密码弹框 -->
        <el-dialog
        title="修改密码"
        :visible.sync="changeDialogVisible"
        width="25%"
        center
        :close-on-click-modal="false"
        @close="changeClose">
            <el-form
            :model="ruleForm"
            status-icon
            :rules="rules"
            ref="ruleForm"
            label-width="80px"
            class="ruleForm">
                <el-form-item label="旧密码" prop="oldPassword">
                    <el-input type="password" v-model="ruleForm.oldPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="新密码" prop="newPassword">
                    <el-input type="password" v-model="ruleForm.newPassword" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkNewPassword">
                    <el-input
                    type="password"
                    @keyup.enter.native="submitForm('ruleForm')"
                    v-model="ruleForm.checkNewPassword"
                    autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item>
                <el-button type="primary" @click="submitForm('ruleForm')">确认修改</el-button>
                <el-button @click="resetForm('ruleForm')">重置</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
        <!-- 选择用户 -->
        <el-dialog
        class="login-dialog"
        :show-close="true"
        title="选择用户"
        :visible.sync="usersDialogVisible"
        width="480px"
        :close-on-click-modal="false"
        @close="closeSelectDialog">
        <div class="userListBox">
            <el-tabs v-model="userType" style="width:100%">
                <el-tab-pane v-if="reviewers.length>0" label="评审" name="评审" style="width:100%">
                    <el-row>
                        <el-col
                        :span="24/(reviewers.length>4?4:reviewers.length%4)"
                        v-for="(item, index) in reviewers"
                        :key="index"
                        style="text-align:center;cursor:pointer;padding:5px;">
                            <div @click="selectUser(item,'评审')">
                                <div class="avatarBox">
                                    <img :src="item.avatar" alt />
                                </div>
                                <span class="avatarName">{{ item.name }}</span>
                                <div>{{ item.currentSchool? item.currentSchool.name : ""  }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane v-if="users.length>0" label="教师" name="教师" style="width:100%">
                    <el-row>
                        <el-col
                        :span="24/(users.length>4?4:users.length%4)"
                        v-for="(item, index) in users"
                        :key="index"
                        style="text-align:center;cursor:pointer;padding:5px;">
                            <div @click="selectUser(item,'教师')">
                                <div class="avatarBox">
                                    <img :src="item.avatar" alt />
                                </div>
                                <span class="avatarName">{{ item.name }}</span>
                                <div>{{ item.currentSchool? item.currentSchool.name : ""  }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane v-if="students.length>0" label="学生" name="学生" style="width:100%">
                    <el-row>
                        <el-col
                        :span="24/(students.length>4?4:students.length%4)"
                        v-for="(item, index) in students"
                        :key="index"
                        style="text-align:center;cursor:pointer;padding:5px;">
                            <div @click="selectUser(item,'学生')">
                                <div class="avatarBox">
                                    <img :src="item.avatar" alt />
                                </div>
                                <span class="avatarName">{{ item.name }}</span>
                                <div>{{ item.currentSchool? item.currentSchool.name : ""  }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
                <el-tab-pane v-if="communityUsers.length>0" label="注册用户" name="注册用户" style="width:100%">
                    <el-row>
                        <el-col
                            :span="24/(communityUsers.length>4?4:communityUsers.length%4)"
                            v-for="(item, index) in communityUsers"
                            :key="index"
                            style="text-align:center;cursor:pointer;padding:5px;"
                        >
                            <div @click="selectUser(item,'注册用户')">
                                <div class="avatarBox">
                                    <img :src="item.avatar" alt />
                                </div>
                                <span class="avatarName">{{ item.name }}</span>
                                <div>{{ item.currentSchool? item.currentSchool.name : ""  }}</div>
                            </div>
                        </el-col>
                    </el-row>
                </el-tab-pane>
            </el-tabs>
        </div>
        </el-dialog>
        <!-- 找回密码 -->
        <el-dialog
        class="login-dialog"
        :show-close="false"
        title="找回密码"
        :visible.sync="retrievePasswordsDialogVisible"
        width="480px"
        :close-on-click-modal="false"
        @close="closeRetrievePasswords"
        >
            <i class="el-icon-close login-close" @click="closeRetrievePasswords"></i>
            <div class="changePasswordBox">
                <el-form
                :model="retrievePassword"
                status-icon
                :rules="rules"
                ref="retrievePasswordRuleForm"
                label-width="100px"
                class="demo-ruleForm"
                >
                <el-form-item label="手机号" prop="phone">
                    <el-input v-model.number="retrievePassword.phone" placeholder="请输入手机号">
                        <el-button
                            :disabled="phoneCodeDisabled"
                            slot="append"
                            @click="getPhoneCode('retrievePasswordRuleForm')"
                        >{{ count ? count + "s 后重发" : "获取验证码"}}</el-button>
                    </el-input>
                </el-form-item>
                <el-form-item label="验证码" prop="phoneCode">
                    <el-input v-model.number="retrievePassword.phoneCode" placeholder="请输入验证码"></el-input>
                </el-form-item>
                <el-form-item label="密码" prop="pass">
                    <el-input
                    type="password"
                    v-model="retrievePassword.pass"
                    autocomplete="off"
                    placeholder="请输入密码"
                    ></el-input>
                </el-form-item>
                <el-form-item label="确认密码" prop="checkPass">
                    <el-input
                    type="password"
                    v-model="retrievePassword.checkPass"
                    autocomplete="off"
                    placeholder="请再次输入密码"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitRevisePassword('retrievePasswordRuleForm')">提交</el-button>
                    <el-button @click="resetForm('retrievePasswordRuleForm')">重置</el-button>
                </el-form-item>
                </el-form>
                <div class="login-default-div">
                <span class="login-default" @click="goRegister('注册')">立即注册</span>
                <span class="login-default" @click="goRegister('登录')">返回登录</span>
                </div>
            </div>
        </el-dialog>
        <LessonDialog ref="lessonDialog"></LessonDialog>
    </div>
</template>
<script>
import communityApi from "@/request/api/community";
import smsApi from "@/request/api/sms";
import authorizationApi from "@/request/api/authorization";
import userApi from "@/request/api/user";
import institutionApi from "@/request/api/institution";
import { mapGetters } from "vuex";
import LessonDialog from '@/views/lesson/component/lessonDialog';

export default {
    components: {
        LessonDialog
    },
    computed: {
        ...mapGetters(["studentId"]),
        dialogVisible: {
            get() {
                return this.$store.state.dialogVisible;
            },
            set() {
                this.$store.commit("setDialogVisible", false);
            }
        },
        themeData() {
            return this.$store.state.themeData;
        },
        changeDialogVisible: {
            get() {
                return this.$store.state.changeDialogVisible;
            },
            set() {
                this.$store.commit("setChangeDialogVisible", false);
            }
        },
        scratchLogin() {
            return this.$store.state.scratchLogin;
        },
        pythonLogin() {
            return this.$store.state.pythonLogin
        },
        callback() {
            return this.$store.state.callback
        },
    },
    data() {
        var checkUsername = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("账号不能为空"));
            } else {
                callback();
            }
        };
        var checkPassword = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else if (value.length < 6) {
                callback(new Error("密码长度不能低于6位"));
            } else {
                if (this.userObj.checkPassword !== "") {
                this.$refs.registration.validateField("checkNewPassword");
                }
                callback();
            }
        };
        var checkPasswords = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入密码"));
            } else if (value.length < 6) {
                callback(new Error("密码长度不能低于6位"));
            } else if (value !== this.userObj.password) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        var checkName = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("姓名不能为空"));
            } else {
                callback();
            }
        };
        var checkPhone = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("手机号不能为空"));
            } else if (value.toString().length != 11) {
                return callback(new Error("请输入正确的手机号"));
            } else if (value.toString().slice(0, 1) != 1) {
                return callback(new Error("请输入正确的手机号"));
            } else {
                callback();
            }
        };
        var checkPhoneCode = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("验证码不能为空"));
            } else if (value.toString().length != 4) {
                return callback(new Error("请输入正确的验证码"));
            } else {
                callback();
            }
        };
        var checkOldPassword = (rule, value, callback) => {
            if (!value) {
                return callback(new Error("请输入旧密码"));
            }
            callback();
        };
        var validatePass = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else if (value.length < 6) {
                callback(new Error("密码长度不能低于6位"));
            } else {
                if (this.ruleForm.checkNewPassword !== "") {
                this.$refs.ruleForm.validateField("checkNewPassword");
                }
                callback();
            }
        };
        var validatePass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入新密码"));
            } else if (value.length < 6) {
                callback(new Error("密码长度不能低于6位"));
            } else if (value !== this.ruleForm.newPassword) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        var retrievingPass1 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请输入密码"));
            } else if (value.length < 6) {
                callback(new Error("密码长度不能低于6位"));
            } else {
                if (this.retrievePassword.pass !== "") {
                this.$refs.retrievePasswordRuleForm.validateField("checkPass");
                }
                callback();
            }
        };
        var retrievingPass2 = (rule, value, callback) => {
            if (value === "") {
                callback(new Error("请再次输入新密码"));
            } else if (value.length < 6) {
                callback(new Error("密码长度不能低于6位"));
            } else if (value !== this.retrievePassword.pass) {
                callback(new Error("两次输入密码不一致!"));
            } else {
                callback();
            }
        };
        return {
            isloginpage: true, //登录 注册界面
            userName: "", //用户名
            password: "", //密码
            count: "",
            students: [], //学生用户列表
            users: [], //教师用户列表
            communityUsers: [], //注册用户列表
            reviewers: [], //评审用户列表
            userObj: {
                phone: "", //手机号
                phoneCode: "", //验证码
                username: "", //用户名
                name: "",
                password: "", //密码
                checkPassword: "" //确认密码
            }, //用户注册
            rules: {
                username: [{ validator: checkUsername, trigger: "blur" }],
                password: [{ validator: checkPassword, trigger: "blur" }],
                checkPassword: [{ validator: checkPasswords, trigger: "blur" }],
                name: [{ validator: checkName, trigger: "blur" }],
                phone: [{ validator: checkPhone, trigger: "blur" }],
                phoneCode: [{ validator: checkPhoneCode, trigger: "blur" }],
                oldPassword: [{ validator: checkOldPassword, trigger: "blur" }],
                newPassword: [{ validator: validatePass, trigger: "blur" }],
                checkNewPassword: [{ validator: validatePass2, trigger: "blur" }],
                pass: [{ validator: retrievingPass1, trigger: "blur" }],
                checkPass: [{ validator: retrievingPass2, trigger: "blur" }]
            },
            ruleForm: {
                oldPassword: "", //旧密码
                newPassword: "", //新密码
                checkNewPassword: "" //确认新密码
            }, //修改密码
            retrievePassword: {
                phone: "",
                phoneCode: "",
                pass: "",
                checkPass: ""
            },
            // changeDialogVisible: false, //修改密码弹框显隐
            phoneCodeDisabled: false, //获取验证码按钮
            usersDialogVisible: false, //选择用户弹框显隐
            retrievePasswordsDialogVisible: false, //找回密码弹框显隐
            userType: "", //角色类型
            selectUserDisabled: true, //选择角色
            userSelect: false, //用户是否选中角色
        };
    },
    methods: {
        //关闭登录弹框
        closeLogin() {
            this.$store.commit("setDialogVisible", false);
            this.userName = "";
            this.password = "";
            if (!this.isloginpage) {
                this.$refs["registration"].resetFields();
            }
            this.isloginpage = true;
        },
        //登录
        goLogin() {
            if (this.userName && this.password) {
                let loginInfo = {
                    institutionId: this.themeData.id,
                    username: this.userName,
                    password: this.password
                };
                authorizationApi.communityLogin(loginInfo, res => {
                    if (res.succeed) {
                        this.users = res.data.users ? res.data.users : [];
                        this.students = res.data.students ? res.data.students : [];
                        this.communityUsers = res.data.communityUsers
                        ? res.data.communityUsers
                        : [];
                        this.reviewers = res.data.reviewers ? res.data.reviewers : [];

                        if (this.reviewers.length > 0) this.userType = "评审";
                        else if (this.users.length > 0) this.userType = "教师";
                        else if (this.students.length > 0) this.userType = "学生";
                        else this.userType = "注册用户";

                        let accountNum =
                            this.users.length +
                            this.students.length +
                            this.communityUsers.length +
                            this.reviewers.length;
                        userApi.setToken(res.data.token);
                        if (accountNum > 1) {
                            this.usersDialogVisible = true;
                            this.$store.commit("setDialogVisible", false);
                        } else {
                            this.getUserInfo();
                            if (this.$route.name == "sh") this.scratchLogin();
                            else if(this.$route.name == "py") this.pythonLogin();
                        }
                    }
                });
            }
        },
        //关闭修改密码弹框
        changeClose() {
            this.resetForm("ruleForm");
        },
        //关闭找回密码弹框
        closeRetrievePasswords() {
            this.retrievePasswordsDialogVisible = false;
            this.resetForm("retrievePasswordRuleForm");
        },
        //去找回密码
        goRetrievePasswords() {
            this.retrievePasswordsDialogVisible = true;
            this.$store.commit("setDialogVisible", false);
        },
        //获取手机验证码
        getPhoneCode(formName) {
            this.$refs[formName].validateField("phone", valid => {
                if (valid == "") {
                    const TIME_COUNT = 60;
                    this.phoneCodeDisabled = true;
                    this.count = TIME_COUNT;
                    this.timer = setInterval(() => {
                        if (this.count > 0 && this.count <= TIME_COUNT) {
                        this.count--;
                        } else {
                        clearInterval(this.timer);
                        this.timer = null;
                        this.phoneCodeDisabled = false;
                        }
                    }, 1000);
                    if (formName == "registration") {
                        smsApi.registerVCode(this.userObj.phone, res => {});
                    } else if (formName == "retrievePasswordRuleForm") {
                        smsApi.communityChangePassVCode(
                        this.retrievePassword.phone,
                        res => {}
                        );
                    }
                }
            });
        },
        //提交注册信息
        submitRegistration(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let check = {
                        phone: this.userObj.phone,
                        code: this.userObj.phoneCode
                    };
                    smsApi.checkVCode(check, res => {
                        if (res.succeed) {
                            let params = {
                                institutionId: this.themeData.id,
                                username: this.userObj.username,
                                password: this.userObj.password,
                                name: this.userObj.name,
                                phone: this.userObj.phone
                            };
                            communityApi.userRegister(params, res => {
                                if (res.succeed) {
                                    this.$message({
                                        message: "恭喜你，注册成功",
                                        type: "success"
                                    });
                                    this.closeLogin();
                                    this.isloginpage = false;
                                } else {
                                    this.$message.error(res.msg);
                                }
                            });
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        //显示注册
        goRegister(type) {
            if (type == "注册") {
                this.isloginpage = false;
                this.$store.commit("setDialogVisible", true);
                this.retrievePasswordsDialogVisible = false;
            } else if (type == "登录") {
                this.isloginpage = true;
                this.$store.commit("setDialogVisible", true);
                this.retrievePasswordsDialogVisible = false;
            }
        },
        //提交找回密码修改后的密码
        submitRevisePassword(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        phone: this.retrievePassword.phone,
                        code: this.retrievePassword.phoneCode,
                        pwd: this.retrievePassword.pass
                    };
                    authorizationApi.communityUpdatePwdByCode(params, res => {
                        if (res.succeed) {
                            this.$message({
                                message: "修改成功",
                                type: "success"
                            });
                            this.retrievePasswordsDialogVisible = false;
                        }
                    });
                }
            });
        },
        //重置
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        //提交修改的密码
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    let params = {
                        oldPwd: this.ruleForm.oldPassword,
                        newPwd: this.ruleForm.newPassword
                    };
                    authorizationApi.updateStudentPwd(params, res => {
                        if (res.succeed) {
                            this.$message({
                                message: "修改成功",
                                type: "success"
                            });
                            this.$store.commit("setChangeDialogVisible", false);
                            this.resetForm("ruleForm");
                        }
                    });
                } else {
                    return false;
                }
            });
        },
        //token之后获取用户信息
        getUserInfo() {
            if (userApi.getToken() && !this.studentId) {
                userApi.getCurrentUser(res => {
                    if (res.succeed) {
                        this.$store.commit("setDialogVisible", false);
                        this.$store.commit("setUserInfo", res.data);
                        this.$store.commit("setLoginBtnShow", false);
                        this.callback? this.callback() : null;
                        if(this.$route.name != 'matchDetail' && res.data.institution.realmNameHead != 'roborobo' && this.$route.name != 'classroom') 
                            this.$store.commit("setLessonDialogShow", true)
                    }
                });
            }
        },
        //选择用户
        selectUser(item, type) {
            if (this.selectUserDisabled) {
                this.userSelect = true;
                this.selectUserDisabled = false;
                let params = {
                    userId: item.id,
                    type: type
                };
                authorizationApi.communitySwitchAccount(params, res => {
                    if (res.succeed) {
                        this.usersDialogVisible = false;
                        this.selectUserDisabled = true;
                        userApi.setToken(res.data.token);
                        this.getUserInfo();
                        if (this.$route.name == "sh") this.scratchLogin();
                        else if(this.$route.name == "py") this.pythonLogin();
                        
                    }
                });
            }
        },
        //关系选择弹框
        closeSelectDialog() {
            if(!this.userSelect) {
                userApi.deleteToken()
            }
        },
    }
};
</script>
<style lang="scss">
.dialogBox {
    .el-dialog__body {
        padding-bottom: 10px;
    }
    .loginInfo .defaultReminder {
        display: block;
        width: 100%;
        color: #999;
        font-size: 12px;
        padding-bottom: 10px;
    }
    .login-default-div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
        padding: 0 20px;
        margin: 20px 0 0;
    }
    .login-default {
        color: #999;
        cursor: pointer;
    }
    .login-default:hover {
        color: #666;
    }
    .el-dialog__body {
        padding-bottom: 10px;
    }
    .el-button--primary {
        background-color: var(--theme-color);
        border-color: var(--theme-color);
    }
    .el-button:focus,
    .el-button:hover {
        color: var(--theme-color);
    }
    .el-button--primary:focus,
    .el-button--primary:hover {
        background: var(--theme-color);
        border-color: var(--theme-color);
    }
    .el-button--primary:focus,
    .el-button--primary:hover {
        color: #fff;
    }
    .login-close {
        position: absolute;
        top: 5px;
        right: 5px;
        font-size: 25px;
        cursor: pointer;
    }
    .loginInfo {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 10px 20px;
        padding-bottom: 0;
    }
    .btn-login {
        font-weight: bold;
    }
    .loginInfo span {
        display: block;
        color: #000;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 30px;
    }
    .loginInfo input {
        width: 100%;
        padding: 25px 25px;
        font-size: 15px;
        outline: none;
        border: 1px solid var(--theme-color);
        border-radius: 30px;
    }
    .loginInfo input:nth-child(1) {
        margin-bottom: 15px;
    }
    .loginInfo input:focus {
        box-shadow: 0 0 0 0.25rem hsla(215, 100%, 65%, 0.35) !important;
    }
    .loginInfo button {
        width: 100%;
        background-color: var(--theme-color);
        border-radius: 20px !important;
        font-size: 18px;
        color: var(--theme-fontColor);
        padding: 10px 18px;
        border: none;
        outline: none;
        cursor: pointer;
    }
    .form-control:focus {
        border-color: var(--theme-color) !important;
    }
    .login-dialog .el-dialog {
        display: block;
        color: #000;
        font-size: 18px;
        font-weight: bold;
        padding-bottom: 10px;
        border-radius: 10px;
    }
    .login-dialog .el-dialog .el-dialog__header {
        color: #000;
        font-size: 18px;
        text-align: center;
        font-weight: bold;
    }
    .userListBox {
        display: flex;
        flex-flow: row wrap;
        justify-content: center;
        align-items: center;
    }
    .userListBox .userInfoBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 120px;
        margin: 10px;
        border: 2px solid #fff;
        border-radius: 5px;
        user-select: none;
    }
    .userListBox .userInfoBox:active {
        border: 2px solid var(--theme-color);
    }
    .userListBox .avatarBox {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        border: 1px solid #aaaaaa;
        margin: 0 auto;
        overflow: hidden;
    }
    .userListBox .avatarName {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .userListBox .avatarBox img {
        height: 100%;
        text-align: center;
    }
    .userListBox .userInfoBox span {
        font-size: 14px;
    }
    .ruleForm {
        padding: 0 10px;
    }
    .changePasswordBox {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding: 15px;
        min-height: 200px;
    }
    .changePasswordBox .verificationBtn {
        padding: 10px 25px;
    }
    .demo-ruleForm {
        width: 100%;
    }

    @media (max-width: 880px) {
        .el-dialog {
            width: 100% !important;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/loginDialog.vue